module.exports = __webpack_public_path__ + "media/recipes/110-53aba74f.png";